import { formatPrice, calculateDiscount } from '../../lib'

interface DiscountBadgeProps {
  price: number
  specialPrice?: number | null
}

const BADGE_CLASSES = 'absolute top-2 left-2 z-10 h-7 xl:h-8 px-2 bg-main-color text-text-color text-base xl:text-xl font-bold flex items-center justify-center font-sec-font'

export function DiscountBadge({ price, specialPrice }: DiscountBadgeProps) {
  const discount = calculateDiscount(price, specialPrice)

  if (discount <= 0) return null

  const label = `- ${formatPrice(discount)}`

  return (
    <span className={BADGE_CLASSES} aria-label={`Reducere ${formatPrice(discount)}`}>
      {label}
    </span>
  )
}
